import { Component, ContentChild, ElementRef, inject, input, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FilterService } from '../../services/filter.service';
import { Observable, Subject } from 'rxjs';
import { CustomExportItem, ExportOptions, ExportService, ExportType } from '../../services/export.service';
import { switchMap } from 'rxjs/operators';
import { Table } from '@cumlaude/metadata';
import { AttOverrides } from '@cumlaude/shared-dashboard-registry';
import { LoadingService, LoadingType } from '../../services/loading.service';
import { AsyncPipe } from '@angular/common';
import { SvgSpinnerComponent } from '../svg-spinner/svg-spinner.component';
import { UserTabMenuComponent } from '../user-tab-menu/user-tab-menu.component';
import { ClickBlockingOverlayComponent } from '../click-blocking-overlay/click-blocking-overlay.component';
import { LegendaComponent } from '../../legenda/legenda.component';
import { DashboardActiesComponent } from '../dashboard-acties/dashboard-acties.component';
import { NavigatieVoorkeurService } from '../../services/navigatie-voorkeur.service';

@Component({
	selector: 'app-dashboard-container',
	templateUrl: './dashboard-container.component.html',
	styleUrls: ['./dashboard-container.component.scss'],
	imports: [UserTabMenuComponent, SvgSpinnerComponent, AsyncPipe, ClickBlockingOverlayComponent, DashboardActiesComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardContainerComponent {
	protected readonly filterService = inject(FilterService);
	protected readonly navigatieVoorkeurService = inject(NavigatieVoorkeurService);

	startExport$ = new Subject<ElementRef | undefined>();
	showSpinner$: Observable<boolean>;

	@Input()
	factTable?: Table;

	/** Zie Dashboard.attOverrides; nodig omdat de exportdialog het dashboard zelf niet kent. */
	@Input()
	attOverrides: AttOverrides = {};

	shareVisible = input(true);

	exportTypes = input(Object.values(ExportType));

	/** Zet op false om de hele filterbalk (filters + Delen/Exporteren) te verbergen, bv. in full-screen. */
	filterbalkVisible = input(true);

	@ContentChild(LegendaComponent)
	private readonly legendaComponent?: LegendaComponent;

	customExportItems = input<CustomExportItem[]>([]);

	/**
	 * emit wanneer de gebruiker de export-dialog met bevestigen heeft afgesloten
	 */
	@Output()
	doExport: Observable<ExportOptions>;

	constructor() {
		const exportService = inject(ExportService);
		const loadingService = inject(LoadingService);

		this.doExport = this.startExport$.pipe(
			switchMap((triggerElement) =>
				exportService.startExport(
					triggerElement,
					this.factTable!,
					this.attOverrides,
					this.exportTypes(),
					this.legendaComponent?.options(),
					this.customExportItems()
				)
			)
		);
		this.showSpinner$ = loadingService.shouldShowLoadingIndicator(LoadingType.TABLE);
	}
}
